import { createAction } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { ResourceFeature } from '@mews-commander/resources';
import { sortByName, createOptionsSelector } from '@mews-commander/utils';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createEntitiesReducer, createBaseEntitySelectors } from './utils';

export const NAME = 'resourceFeatures';

export const RESOURCE_FEATURES_UPDATE = prefix('RESOURCE_FEATURES_UPDATE');

export const [getResourceFeatures, getResourceFeaturesByIds, getResourceFeaturesByOwnerId, getResourceFeature] =
    createBaseEntitySelectors<ApplicationState, ResourceFeature, typeof NAME>(parentSelector, NAME);

export const setResourceFeatures = (entities: Array<ResourceFeature>) =>
    createAction(RESOURCE_FEATURES_UPDATE, entities);

export const resourceFeaturesReducer = createEntitiesReducer({
    UPDATE_SUCCESS: RESOURCE_FEATURES_UPDATE,
});

export const getResourceFeatureOptions = createOptionsSelector(getResourceFeatures, {
    sortFunction: sortByName,
});
